import React from 'react';
import { Mail, MessageCircle } from 'lucide-react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function SettingsInboxesPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const channels = data?.workspace?.mailChannels || [];

  return (
    <MainPanel title={t('settingsPages.inboxesTitle')} subtitle={t('settingsPages.inboxesSubtitle')}>
      {channels.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('settingsPages.inboxesEmpty')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('settingsPages.inboxesEmptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {channels.map((ch) => {
            const Icon = (ch.channelKind || '').toLowerCase() === 'email' ? Mail : MessageCircle;
            return (
              <div
                key={ch.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '14px 18px',
                  background: '#1f2229',
                  borderRadius: 12,
                  border: '1px solid rgba(255,255,255,0.06)',
                  color: '#f3f4f6',
                }}
              >
                <Icon size={20} color="#9ca3af" />
                <div>
                  <div style={{ fontWeight: 600 }}>{ch.name}</div>
                  <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>{ch.channelKind || 'channel'}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </MainPanel>
  );
}
